import { create } from '@dojo/framework/core/vdom';
import { i18n } from '@dojo/framework/core/middleware/i18n';

import { Messages, Bundle } from '@dojo/framework/i18n/i18n';
import { LocalizedMessages } from '@dojo/framework/core/mixins/I18n';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { MiddlewareResultFactory, MiddlewareMap, WidgetProperties } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, I18nProperties, LocaleData } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { RegistryHandler } from '@dojo/framework/core/RegistryHandler';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { StoreApi } from '@holmescorp/middleware';

import { lccstate } from './base';

const factory = create({ lccstate, i18n });

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createNlsMiddleware = (namespace: string) => {
	const nlsMiddleware = factory(({ middleware: { lccstate, i18n } }) => {
		return (): LocalizedMessages<Messages> => {
			const { get, path } = lccstate;
			const dynls = get(path('dynls'));
			const bundle: Bundle<Messages> | undefined = dynls && dynls.get(namespace);
			if (!bundle) {
				return { isPlaceholder: true, format: () => '', messages: {} as Messages };
			}
			return i18n.localize(bundle);
		};
	});
	return nlsMiddleware;
};
